import type { RaterXCoverage } from '../../../../api/types/rater-x-preset';

type StandardCoverageOptions = {
  allowDeductibleValueWithoutLimit?: boolean;
};

export const isStandardCoverage = (
  coverage: RaterXCoverage,
  options?: StandardCoverageOptions
) => {
  const hasLimitRule = Boolean(coverage.rules?.limit);
  const hasDeductibleRule = Boolean(coverage.rules?.deductible);
  const hasLimitValue = Boolean(coverage.value?.props?.limit?.value);

  if (!(hasLimitRule || hasDeductibleRule)) {
    return false;
  }

  if (options?.allowDeductibleValueWithoutLimit) {
    const hasDeductibleValue = coverage.value?.props?.deductible?.value != null;
    return hasLimitValue || hasDeductibleValue;
  }

  return hasLimitValue;
};
